import { genericService } from "./genericService";

const section = "Zone";

function filter(name = " ", from = "0", limit = "10", active = "1") {
  return genericService.filter(section, "zones", name, from, limit, active);
}

function getAll() {
  return genericService.get("Zone/ListAllZone");
}
function remove(id) {
  return genericService.remove(section, id);
}

function create(item) {
  const param = {
    Zone: item.zone,
  };
  return genericService.create(section, param);
}

function update(item) {
  const param = {
    id: item.id,
    Zone: item.zone,
    isActive: item.isActive,
  };
  return genericService.update(section, param);
}

export const zoneService = {
  getAll,
  filter,
  remove,
  create,
  update,
};
